<template>
  <b-row>
    <b-col md="12">
      <div class="table-responsive">
        <h6 class="package-title">Detalii zbor</h6>
        <table class="table table-sm border table-hover">
          <thead class="t-head hh-t-head">
            <tr>
              <td>Zbor</td>
              <td>Nr. zbor</td>
              <td>Data</td>
              <td>Decolare</td>
              <td>Ora</td>
              <td>Aterizare</td>
              <td>Ora</td>
              <td>Durata zbor</td>
            </tr>
          </thead>
          <tbody>
            <template v-for="(leg, legIndex) in info.outbound">
              <tr :key="legIndex + 'fout'">
                <td>Dus</td>
                <td>{{ leg.airline }} {{ leg.flight }}</td>
                <td>{{ leg.date }}</td>
                <td>{{ leg.from_name }}</td>
                <td>{{ leg.depTime == '00:00' ? 'n/a' : leg.depTime  }}</td>
                <td>{{ leg.to_name }}</td>
                <td>{{ leg.arrTime == '00:00' ? 'n/a' : leg.arrTime }}</td>
                <td>{{ leg.duration }}</td>
              </tr>
            </template>
            <template v-for="(leg, legIndex) in info.inbound">
              <tr :key="legIndex + 'fin'">
                <td>Intors</td>
                <td>{{ leg.airline }} {{ leg.flight }}</td>
                <td>{{ leg.date }}</td>
                <td>{{ leg.from_name }}</td>
                <td>{{ leg.depTime == '00:00' ? 'n/a' : leg.depTime  }}</td>
                <td>{{ leg.to_name }}</td>
                <td>{{ leg.arrTime == '00:00' ? 'n/a' : leg.arrTime }}</td>
                <td>{{ leg.duration }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'FlightInfo',
  props: ['info']
}
</script>
